export default __webpack_public_path__ + "static/media/card-02.6e817081.jpg";